import { createAction } from "redux-actions";

export const SET_CART_DATA = "SET_CART_DATA";
export const setCartData = createAction(SET_CART_DATA);
